import type { WorkItemDto } from '@customTypes/types';
import { WorkItemTypes } from '@customTypes/types';
import { useQueryClient } from '@tanstack/react-query';

import {
  useUpdateWorkInviteMutation,
  useUpdateWorkRequestMutation
} from '@/features/work/api';

import { interactionWorkItemsStatusFilters } from '../../constants';

export const useManageCurrentContractView = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const queryClient = useQueryClient();
  const workInviteMutation = useUpdateWorkInviteMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            'ArtistWorkItemsList',
            workItem.clubProfileId.toString(),
            interactionWorkItemsStatusFilters
          ],
          exact: true
        });
      }
    }
  });
  const workRequestMutation = useUpdateWorkRequestMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            'ArtistWorkItemsList',
            workItem.clubProfileId.toString(),
            interactionWorkItemsStatusFilters
          ],
          exact: true
        });
      }
    }
  });

  const requestEndDate = async () => {
    if (workItem.workItemType === WorkItemTypes.Invite) {
      await workInviteMutation.mutateAsync(
        {
          params: {
            workInviteId: workItem.workItemId,
            artistRequestedEndDate: true,
            approvedByArtist: true
          }
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [
                'ArtistWorkItemsList',
                workItem.clubProfileId.toString(),
                interactionWorkItemsStatusFilters
              ],
              exact: true
            });
          }
        }
      );
    }
    if (workItem.workItemType === WorkItemTypes.Request) {
      await workRequestMutation.mutateAsync(
        {
          params: {
            workRequestId: workItem.workItemId,
            artistRequestedEndDate: true,
            approvedByArtist: true
          }
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [
                'ArtistWorkItemsList',
                workItem.clubProfileId.toString(),
                interactionWorkItemsStatusFilters
              ],
              exact: true
            });
          }
        }
      );
    }
  };

  const acceptNewEndDate = async () => {
    if (workItem.workItemType === WorkItemTypes.Invite) {
      await workInviteMutation.mutateAsync(
        {
          params: {
            workInviteId: workItem.workItemId,
            approvedByArtist: true
          }
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [
                'ArtistWorkItemsList',
                workItem.clubProfileId.toString(),
                interactionWorkItemsStatusFilters
              ],
              exact: true
            });
          }
        }
      );
    }
    if (workItem.workItemType === WorkItemTypes.Request) {
      await workRequestMutation.mutateAsync(
        {
          params: {
            workRequestId: workItem.workItemId,
            approvedByArtist: true
          }
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [
                'ArtistWorkItemsList',
                workItem.clubProfileId.toString(),
                interactionWorkItemsStatusFilters
              ],
              exact: true
            });
          }
        }
      );
    }
  };

  return {
    functions: { requestEndDate, acceptNewEndDate }
  };
};
